import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainPage from "./Main";
import Auth from "./Auth";

function App() {
    const [user, setUser] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Проверяем сохраненную сессию
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (e) {
                console.error("Ошибка парсинга пользователя", e);
                localStorage.removeItem('user');
            }
        }
        setIsReady(true);
    }, []);

    if (!isReady) return null;

    return (
        <div className="App">
            <Router>
                <Routes>
                    {/* Страница авторизации */}
                    <Route
                        path="/auth"
                        element={!user ? <Auth onLogin={setUser} /> : <Navigate to="/" replace />}
                    />

                    {/* Главная страница (только один Route!) */}
                    <Route
                        path="/"
                        element={
                            user ? (
                                <MainPage user={user} setUser={setUser} />
                            ) : (
                                <Navigate to="/auth" replace />
                            )
                        }
                    />

                    {/* Редирект для всех остальных ссылок */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;